import { compose, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import { showUpdateCancelInstructionsModal } from '../UpdateCancelInstructionsModal/actions'
import AppointmentDetails from './AppointmentDetails'
import { getGoogleMapsDirections, getEmailModalProps } from './helpers'

export default compose(
  connect(null, { showUpdateCancelInstructionsModal }),
  withHandlers({
    showUpdateCancelInstructionsModalHandler: ({
      showUpdateCancelInstructionsModal,
      updateCancelAppointment
    }) => () => showUpdateCancelInstructionsModal(updateCancelAppointment)
  }),
  withProps(
    ({ storeCoordinates, emailModalData }) => ({
      googleMapsDirections: getGoogleMapsDirections(storeCoordinates),
      emailModalProps: getEmailModalProps(emailModalData)
    })
  )
)(AppointmentDetails)
